import React from 'react';
import {Grid} from '@material-ui/core';
import {FormikErrors} from 'formik/dist/types';
import {IHotelInfo} from 'data/interfaces/products';
import HotelDescription from './components/hotelDescription';
import EditorSection from '../../../../../commons/editor/components/editorSection';
import PlaceSelector from 'gui/components/editors/commons/editor/components/placeSelector/PlaceSelector';

const HotelDetails = (props: { values: IHotelInfo, submitCount: number, errors: FormikErrors<any>, setFieldValue: any }) => (
  <EditorSection title="פרטי מלון">
    <PlaceSelector
      placeKey={'hotel'}
      label={'בית מלון *'}
      description={'בחר/י בית מלון'}
    />
    <Grid item xs={12} style={{paddingTop: 0, marginTop: props.values.hotel !== undefined ? 20 : 0}}>
      <HotelDescription values={props.values}/>
    </Grid>
  </EditorSection>
);

HotelDetails.defaultProps = {
  values: {},
  errors: [],
  submitCount: 0,
  setFieldValue: () => null,
};

export default React.memo(HotelDetails);
